import { getApiLink } from "../apiConfig";
import { iTagShort__API } from "../apiSchema";
import API from "../enums/API";
import { iTagExtended, TagExtended } from "../models/Tag";
import { useData } from "../../hooks/useData";
import useFetch from "use-http";

export default function useTagsShort () {
    const { get } = useFetch();
    async function getTags(): Promise<iTagExtended[]> {
        const response: iTagShort__API[] = await get(getApiLink(API.GET_TAGS_SHORT));
        // GET_TAGS_SHORT returns id+value only; the extra iTagExtended fields are unused by
        // tag-selector consumers, so default them here.
        return response.map(tag => new TagExtended({ subModel: { id: tag.id, title: tag.value ?? "", publicationsIds: [], isAvailableForNews: false, definition: "" } }));
    }

    return useData(([] as iTagExtended[]), getTags);
};